// extracted by mini-css-extract-plugin
module.exports = {"LegendItem__legend-item___1PLFt":"LegendItem__legend-item___1PLFt","LegendItem__label___25DOn":"LegendItem__label___25DOn","LegendItem__check___6D6lR":"LegendItem__check___6D6lR"};